import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from '../../Modal/Modal'
import CheckboxesList from '../../FormComponents/CheckboxesList/CheckboxesList'
import { hideModal } from '../../../store/reducers/modal'
import { updateUserData } from '../../../store/reducers/clientUsers'
import { editDeleteStyles } from '../../../globals'
import { constants } from '../constants'
import '../../../styles/ModalStyles.scss'

class PermissionsModal extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      isEdited: false
    }
    this.closeModal = this.closeModal.bind(this)
    this.savePermissionChanges = this.savePermissionChanges.bind(this)
  }

  closeModal = () => {
    const { hideModal, id } = this.props
    hideModal(`Permissions-${id}`)
  }

  savePermissionChanges = () => {
    const { hideModal, id, sendEditedPermissions } = this.props
    this.setState({ isEdited: true })
    sendEditedPermissions(true)
    hideModal(`Permissions-${id}`)
  }

  updatePermissionsList = () => {
    return constants.permissions.map(item => {
      return {
        id: item.PermissionId,
        text: item.PermissionName,
        type: 'checkbox'
      }
    })
  }

  render () {
    const { id, trackData, updateUserData, modal } = this.props
    return <Modal
      modalType={`Permissions-${id}`}
      contentLabel="Permissions"
      customStyles={editDeleteStyles.edit}
      modal={modal}
    >
      <div className="get-report-modals-titlearea">
        <span className="get-report-modals-title">Permissions</span>
        <div className="restore-btn">Restore to Default</div>
      </div>
      <div className="background-white permissions-body custom-scroll">
        <CheckboxesList
          location={{ id, field: 'permissions' }}
          fieldData={this.updatePermissionsList()}
          values={trackData[id] ? trackData[id].permissions : {}}
          updateData={updateUserData}
        />
      </div>
      <div className="get-report-modals-buttons-area buttonsarea-type2">
        <button onClick={this.savePermissionChanges}>Save</button>
        <button onClick={this.closeModal}>Close</button>
      </div>
    </Modal>
  }

  static propTypes = {
    id: PropTypes.any,
    hideModal: PropTypes.func,
    trackData: PropTypes.object,
    updateUserData: PropTypes.func,
    sendEditedPermissions: PropTypes.func,
    modal: PropTypes.object
  }
}

export default connect(state => ({
  trackData: state.clientUsers.formDataValue.clientUsers
}), {
  hideModal,
  updateUserData
})(PermissionsModal)



// WEBPACK FOOTER //
// ./src/components/ManagementUserList/components/PermissionsModal.js